import Vue from 'vue';
import {store} from './../../plugins/vuex/index'
import _ from 'lodash';

function hasPermission(permission) {
  if (!permission) {
    return true;
  }

  if (!store) {
    return false
  }

  if (store.state.global.currentUser.is_superuser) {
    return true;
  }

  if (typeof permission === 'string') {
    return store.state.global.currentUser.permissions.includes(permission);
  }

  let permissions = _.cloneDeep(permission)
  const method = permissions.shift()

  if (permissions.length === 0) {
    return false
  }

  if (method === 'OR') {
    for (const p of permissions) {
      if (hasPermission(p)) {
        return true
      }
    }
    return false
  } else if (method === 'AND') {
    for (const p of permissions) {
      if (!hasPermission(p)) {
        return false
      }
    }
    return true
  }

  return false;
}

function checkPermission(el, binding) {
  if (binding.value) {
    let allowed = hasPermission(binding.value);
    el.style.display = !allowed ? 'none' : '';
  }
}

Vue.directive('permission', {
  inserted: checkPermission,
  updated: checkPermission,
  componentUpdated: checkPermission
});

export {
  hasPermission
}
